import React from "react";
import { Img } from "../Img";
export const SectionWithAwardsCard = ({ content, imgUrl }) => (React.createElement("div", { className: "section-with-awards-card-root" },
    React.createElement(Img, { className: "section-with-awards-card-root__image", src: imgUrl }),
    React.createElement("p", null, content)));
